<template>
  <div>

    <Chart v-show="show" :cdata="cdata" />
    <div style="font-size: 10px;margin-top: -10px;color: #00a2ca">{{title}}</div>
  </div>
</template>

<script>
  import Chart from './chart.vue'
  import enumsUtil from "@/utils/enumsUtil";
  import commonUtils from "@/utils/commonUtils";
  export default {

    props: {
      clue: {
        type: Object,
        default: () => ({})
      },
    },
    watch: {
      clue: {
        handler (newData) {
          this.setData();
        },
        immediate: true,
        deep: true
      }
    },

    data () {
      return {
        drawTiming: null,
        cdata: {
          year: null,
          weekCategory: [],
          maxData: 100,
          weekLineData: []
        },
        dayConsumeData:[],
        title:"基础游",
        lessonTemplateId:enumsUtil.lessonTemplateIdBS(),
        show:true,
      }
    },
    components: {
      Chart,
    },
    mounted () {
      this.drawTimingFn();
    },
    beforeDestroy () {
      clearInterval(this.drawTiming);
    },
    methods: {
      drawTimingFn () {
        this.setData();
        this.drawTiming = setInterval(() => {
          this.setData();
        }, 10000);
      },
      setData () {
        // 清空轮询数据
        this.cdata.weekCategory = [];
        this.cdata.weekLineData = [];

        let dateBase = new Date();
        this.cdata.year = dateBase.getFullYear();
        if (this.lessonTemplateId ==enumsUtil.lessonTemplateIdCF()){
          this.lessonTemplateId =enumsUtil.lessonTemplateIdBS();
          this.title = "基础游"
          this.dayConsumeData = this.clue.dayBSConsumeDataList;

        }
        else if (this.lessonTemplateId == enumsUtil.lessonTemplateIdBS()){
          this.lessonTemplateId =enumsUtil.lessonTemplateIdCF();
          this.title = "亲子游"
          this.dayConsumeData = this.clue.dayFCConsumeDataList;

        }
        if (commonUtils.isArrayNull(this.dayConsumeData)){
          this.dayConsumeData = [];
        }
        // 周数据
        for (let i = 0; i < this.dayConsumeData.length; i++) {
          // 日期
          let date = this.dayConsumeData[i].day + '日';
          this.cdata.weekCategory.push(date);
          // 折线图数据
          let distance = this.dayConsumeData[i].consumeNum;
          this.cdata.weekLineData.push(distance);
        }


      }
    }
  };
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/echart/TypeLine2/index.vue